import { connect } from 'react-redux';
import type { Props } from '../components/EarningsPerShareGrowth';
import { EarningsPerShareGrowthRawData } from '../components/EarningsPerShareGrowth';
import { getFutureEPSRawDataProps } from '../redux/selectors';

interface OwnProps {
  companyId?: string;
}
type StateProps = Pick<
  Props,
  | 'uniqueSymbol'
  | 'reportingCurrencyISO'
  | 'lastEarningsUpdate'
  | 'analystCount'
  | 'futureEPSEstimates'
  | 'pastEPS'
>;
const mapStateToProps = (state, ownProps: OwnProps): StateProps => {
  const rawDataModalProps = getFutureEPSRawDataProps(state, ownProps);
  return rawDataModalProps;
};

export default connect<StateProps, unknown, OwnProps>(mapStateToProps)(
  EarningsPerShareGrowthRawData
);
